import React, { FC, useMemo } from 'react';
import { Section } from 'omni-package-react-core';
import { useTranslation } from 'react-i18next';
import { PersonalInformation } from '../../interfaces/PersonalInformation';
import { StyledP } from './Gender.styles';

export interface GenderProps {
  personalInfo: PersonalInformation;
}
const Gender: FC<GenderProps> = ({ personalInfo }) => {
  const { t } = useTranslation('Gender');
  const genderLabel = useMemo(() => {
    let l = 'undetermined';
    if (personalInfo?.identification?.gender.toUpperCase() === 'M') l = 'male';
    if (personalInfo?.identification?.gender.toUpperCase() === 'F') l = 'female';

    return t(l);
  }, [personalInfo, t]);

  if (!personalInfo) return null;
  if (!personalInfo.identification) return null;
  if (personalInfo.identification.gender === '') return null;
  if (personalInfo.identification.behaviours.showGender === false) return null;

  return (
    <Section name={t('title')}>
      <StyledP>{genderLabel}</StyledP>
    </Section>
  );
};
export default Gender;
